/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
import { callApiServiceCommon } from "./service-common";

const blogApi = "https://blog.autoketing.com/autoketingblog-posts";
const api = `${process.env.REACT_APP_API}`;

export function* getListBlogServer(number) {
  const payload = {
    method: "GET",
    url: `${blogApi}`,
    params: {
      "post-per-page": number,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* changeAppStatusServer(status) {
  const payload = {
    method: "POST",
    url: `${api}/v2/active-shop-settings`,
    params: {
      app_status: status,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettingDataServer() {
  const payload = {
    method: "GET",
    url: `${api}/v2/get-current-package-he-v2`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* getShopInfoService(shop_domain) {
  const payload = {
    method: "GET",
    url: `${process.env.REACT_APP_API_COMMON_SERVICE_V1}ak/get-shop-info`,
    params: {
      shop_domain,
      app_code: "he",
    },
  };
  return yield callApiServiceCommon(payload);
}
